import $ from "jquery";
import "qtip2";

function show(event, html, options) {
  var opts = options || {},
    $target = $(event.target);

  var defaults = {
    content: {
      text: html
    },
    position: {
      my: 'bottom center',
      at: 'top center',
      viewport: $(window)
    },
    show: {
      event: event.type,
      ready: true,
      solo: true
    },
    events: {
      hide: function (hideEvent, api) {
        api.destroy(true);
      }
    }
  };
  if (html) {
    $($target).qtip($.extend(true, {}, defaults, opts), event);
  }
}

function init() {
  $.fn.qtip.defaults.style.classes = 'tooltip2';
  $.fn.qtip.defaults.style.tip.height = 15;
  $.fn.qtip.defaults.style.tip.width = 15;
}

export default {
  show: show,
  init: init
};



// WEBPACK FOOTER //
// ./web/js/tooltip.js